import i18n from '@/i18n'

export default function () {
    const required = {
        required: true,
        message: i18n.t('validation.required')
    }

    return {
        required
    }
}
